import { render } from "./alert-error.vue?vue&type=template&id=1bcd0ae7&scoped=true"
import script from "./alert-error.vue?vue&type=script&lang=js"
export * from "./alert-error.vue?vue&type=script&lang=js"

import "./alert-error.vue?vue&type=style&index=0&id=1bcd0ae7&scoped=true&lang=css"

import exportComponent from "/Users/pushpan/Projects/WebApps/Python/Django/store_manage/punil/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bcd0ae7"]])

export default __exports__